
// Theme Sections
import './sections/announcement-bar';
import './sections/footer-banner';
import './sections/text-image';
import './sections/hero-newsletter';
import './sections/image-slider';
import './sections/featured-products';
import './sections/main-product';
import './sections/main-collection-product-grid-boost-pfs-original';
import './sections/main-collection-product-grid';
import './sections/main-collection-banner';
import './sections/image-buttons-slider';
import './sections/col-details';
import './sections/insta-slider';
import './sections/samples';
import './sections/main-cart-items';

// Theme Components

import './partials/miniCart';
import './sections/header';
import './sections/cart';


// Load Theme Sections
import { load } from '@shopify/theme-sections';


// window.formatMoney = formatMoney;



class App {
  constructor() {
    this.init();
  }
  
  

  init() {
    window.initialScrollReset = false;
    window.addEventListener('scroll', (event) => {
      event.preventDefault();
      if (!window.initialScrollReset){
        window.initialScrollReset = true;
        if (window.scrollY > 0 ){
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
          document.body.scrollTop = 0;
          return false;
        }
      }
    });
    window.addEventListener('load', (event) => {
      load('*');
    });
  }
}

const app = new App();


